import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-permission',
  template: `
    <p>
      edit-permission works!
    </p>
  `,
  styles: ``
})
export class EditPermissionComponent {

}
